var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportFilterCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.96338,
    y: 0.851562,
    width: 10.0318,
    height: 10.1885,
    rx: 5.0159,
    transform: "rotate(45 7.96338 0.851562)",
    fill: "#424242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80492 9.41745L8.38457 7.9971L9.82712 6.55455C9.89088 6.49078 9.92709 6.40469 9.92779 6.31521C9.92848 6.22572 9.8936 6.14018 9.83082 6.0774C9.76803 6.01462 9.68249 5.97973 9.59301 5.98043C9.50352 5.98112 9.41743 6.01733 9.35367 6.0811L7.91112 7.52364L6.49077 6.10329C6.42798 6.04051 6.34244 6.00563 6.25296 6.00632C6.16347 6.00701 6.07738 6.04323 6.01362 6.10699C5.94985 6.17075 5.91364 6.25685 5.91295 6.34633C5.91225 6.43581 5.94713 6.52136 6.00992 6.58414L7.43027 8.00449L5.98772 9.44704C5.92396 9.5108 5.88775 9.5969 5.88705 9.68638C5.88636 9.77586 5.92124 9.86141 5.98402 9.92419C6.04681 9.98697 6.13235 10.0219 6.22183 10.0212C6.31132 10.0205 6.39741 9.98426 6.46118 9.92049L7.90372 8.47794L9.32408 9.8983C9.38686 9.96108 9.4724 9.99596 9.56188 9.99527C9.65137 9.99458 9.73746 9.95836 9.80123 9.8946C9.86499 9.83083 9.9012 9.74474 9.9019 9.65526C9.90259 9.56578 9.86771 9.48023 9.80492 9.41745Z",
    fill: "#FFD822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFilterCross);
export default __webpack_public_path__ + "static/media/reportFilterCross.5118b95fb9ad76b4b585220a06a98b23.svg";
export { ForwardRef as ReactComponent };